import React, { createContext, useState, useEffect } from 'react';
import {
    ACCESS_TOKEN_CHANGED_EVENT,
    clearLocalStorage,
    getAccesToken,
    getUser,
} from '../Localstorage/localstorage';

// Create the AuthContext
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // Initialize from localStorage if available
    const [accessToken, setAccessToken] = useState(() => {
        const token = getAccesToken();
        return token || null;
    });
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const token = getAccesToken();
        const user = getUser();
        return !!(token && user); // Authenticated if both token and user exist
    });

    // Sync with localStorage on mount and when token changes elsewhere
    useEffect(() => {
        const syncAuthState = () => {
            const token = getAccesToken();
            const user = getUser();
            setAccessToken(token || null);
            setIsAuthenticated(!!(token && user));
        };

        syncAuthState();

        const onStorageChange = (event) => {
            if (!event?.key || event.key === 'REPEAT_ACCESSTOKEN' || event.key === 'REPEAT_USER') {
                syncAuthState();
            }
        };

        window.addEventListener('storage', onStorageChange);
        window.addEventListener(ACCESS_TOKEN_CHANGED_EVENT, syncAuthState);

        return () => {
            window.removeEventListener('storage', onStorageChange);
            window.removeEventListener(ACCESS_TOKEN_CHANGED_EVENT, syncAuthState);
        };
    }, []);

    // Function to log in and store the access token
    const login = (token) => {
        if (token) {
            setAccessToken(token);
            setIsAuthenticated(true);
        }
    };

    // Function to log out and clear the token
    const logout = () => {
        clearLocalStorage();
        setAccessToken(null);
        setIsAuthenticated(false);
    };

    // Provide the state and functions to all children components
    return (
        <AuthContext.Provider value={{ accessToken, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
